import { HomeScreen } from "@/components/boardblend/home-screen";
import { PublicPageHead } from "@/components/seo/public-page-head";
import {
  SITE_ORGANIZATION_ID,
  SITE_ORIGIN,
  SITE_WEBSITE_ID,
  staticPublicPages,
} from "@/lib/public-seo";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": SITE_WEBSITE_ID,
      name: "Boardblend",
      url: `${SITE_ORIGIN}/`,
    },
    {
      "@type": "Organization",
      "@id": SITE_ORGANIZATION_ID,
      name: "Boardblend",
      url: `${SITE_ORIGIN}/`,
    },
  ],
};

export default function Home() {
  return (
    <>
      <PublicPageHead
        page={staticPublicPages.home}
        structuredData={structuredData}
      />
      <HomeScreen />
    </>
  );
}
